import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import { Mail } from "lucide-react";

const DashboardWelcomeSection = ({
  accountType = "parent",
  // WhatsApp banner props
  showWhatsappBanner = false,
  onVerifyWhatsapp,
  // Email banner props
  showEmailBanner = false,
  emailToVerify = "",
  onSendEmailVerification,
  emailResendLoading = false,
  emailResendCooldown = 0,
  emailSentSuccess = false,
}) => {
  const isStudent = accountType === "student";

  return (
    <div className="space-y-5 text-left">
      {/* WhatsApp Verification Banner (Non-collapsible) */}
      {showWhatsappBanner && (
        <div className="relative flex flex-col sm:flex-row items-center justify-between gap-4 p-4 sm:p-5 bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-100 rounded-2xl shadow-sm animate-fade-in">
          <div className="flex items-center gap-3">
            <FaWhatsapp className="w-8 h-8 text-[#25D366] flex-shrink-0 animate-pulse" />
            <div>
              <p className="text-sm font-bold text-slate-800">
                Verify your WhatsApp number
              </p>
              <p className="text-xs text-slate-500 font-medium mt-0.5">
                Receive important class schedules, test reports, and exam alerts directly on your phone.
              </p>
            </div>
          </div>
          <div className="flex items-center w-full sm:w-auto justify-end">
            <button
              onClick={onVerifyWhatsapp}
              className="px-5 py-2.5 bg-orange-600 hover:bg-orange-700 text-white font-extrabold text-xs rounded-xl shadow-sm transition duration-200 w-full sm:w-auto text-center cursor-pointer"
            >
              Verify Now
            </button>
          </div>
        </div>
      )}

      {/* Email Verification Banner (Non-collapsible) */}
      {showEmailBanner && (
        <div className="relative flex flex-col sm:flex-row items-center justify-between gap-4 p-4 sm:p-5 bg-gradient-to-r from-amber-50 to-orange-50 border border-amber-100 rounded-2xl shadow-sm animate-fade-in">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-full bg-amber-100 text-amber-600 flex items-center justify-center shrink-0">
              <Mail className="w-5 h-5" />
            </div>
            <div>
              <p className="text-sm font-bold text-slate-800">
                Verify your Email address
              </p>
              <p className="text-xs text-slate-500 font-medium mt-0.5">
                Verify <strong className="text-slate-700">{emailToVerify}</strong> to receive exam scorecards, receipts, and account recovery access.
              </p>
            </div>
          </div>
          <div className="flex items-center w-full sm:w-auto justify-end">
            <button
              onClick={onSendEmailVerification}
              disabled={emailResendLoading || emailResendCooldown > 0}
              className="px-5 py-2.5 bg-amber-600 hover:bg-amber-700 disabled:bg-amber-400 text-white font-extrabold text-xs rounded-xl shadow-sm transition duration-200 w-full sm:w-auto text-center cursor-pointer"
            >
              {emailResendLoading
                ? "Sending..."
                : emailResendCooldown > 0
                ? `Resend in ${emailResendCooldown}s`
                : emailSentSuccess
                ? "✓ Link Sent"
                : "Send Verification Link"}
            </button>
          </div>
        </div>
      )}

      {/* Welcome Heading Section */}
      <div className="py-4 sm:py-6 space-y-1.5">
        <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 tracking-tight flex items-center gap-2">
          <span>Welcome!</span>
          <span className="text-2xl sm:text-3xl">👋</span>
        </h2>
        <p className="text-sm sm:text-base text-slate-500 font-medium">
          {isStudent
            ? "Manage your learning journey in AI, Robotics, Coding and more"
            : "Manage your children's learning journey in AI, Robotics, Coding and more"}
        </p>
      </div>
    </div>
  );
};

export default DashboardWelcomeSection;
